<template>
  <section class="pb-8 container-lg">
    <div class="pl-6">
      <h4 class="mb-6" :class="$style.themeTitle">Themes</h4>

      <div class="w-full overflow-x-auto">
        <ul class="w-full md:w-auto mb-4 flex flex-row gap-2 flex-nowrap justify-center items-center divide-x divide-gray-300"
            :class="$style.themeContainer">
          <li class="w-28 last:mr-4 inline-block cursor-pointer px-2"
              @click="handleSelect('DEFAULT')">
            <div :class="['pl-0.5 pb-1.5 text-sm text-gray-600 uppercase',
                         { '!text-primary font-bold': selectedTheme === 'DEFAULT' }]">
              DEFAULT
            </div>
          </li>
          <li v-for="(theme, name) in availableThemes"
              :key="name"
              class="w-32 px-2 last:mr-4 inline-block cursor-pointer"
              @click="handleSelect(name)">
            <div :class="['pl-0.5 pb-1.5 text-sm text-gray-600 uppercase',
                         { '!text-primary font-bold': selectedTheme === name }]">
              {{ formatThemeName(name) }}
            </div>
            <div :class="$style.paletteContainer">
              <div :style="{ backgroundColor: theme.mainColors.primaryColor }"
                   class="w-1/3 h-full rounded-l-md"></div>
              <div :style="{ backgroundColor: theme.mainColors.backgroundColor }"
                   class="w-1/3 h-full"></div>
              <div :style="{ backgroundColor: theme.mainColors.secondaryColor }"
                   class="w-1/3 h-full rounded-r-md"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ThemesFilter',
  computed: {
    ...mapState('templates', {
      availableThemes: (state) => state.themes,
      selectedTheme: (state) => state.selectedTheme,
    }),
  },
  methods: {
    ...mapActions('templates', ['setSelectedTheme']),
    handleSelect(themeName) {
      this.setSelectedTheme(themeName)
    },
    formatThemeName(key) {
      return key
          .toLowerCase()
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.themeTitle {
  padding-bottom: 4px;
  margin-bottom: 15px;
  font-weight: 500;
  border-bottom: 1px solid $color-light-grey;
}

.themeContainer {
  width: fit-content;
  flex-wrap: nowrap;
}

.paletteContainer {
  @apply w-full h-2 rounded-md relative flex;

  aspect-ratio: 16/9;
  border: 1px solid #e8eae7;
}
</style>
